export class BotEnvironments {
    public static readonly test = 'Test';
    public static readonly prod = 'Prod';
}
